export default __webpack_public_path__ + "static/media/add-client.aa2cad74.svg";